import {memo, useEffect, useRef} from 'react';

import './style.css.js';

declare global {
  interface Window {
    announcekit?: {
      queue?: unknown[];
      on: (event: string, callback: () => void) => void;
      push: (config: {
        widget: string;
        selector: string;
        badge?: {style: Record<string, string>};
      }) => void;
    };
  }
}

export const WhatsNew = memo(function WhatsNew() {
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    window.announcekit?.push({
      widget: 'https://changelog.growthloop.com/widgets/v2/2dvhh6',
      selector: '.announcekit-widget-react',
    });
  }, []);

  return (
    <div ref={widgetRef}>
      <div className="announcekit-widget announcekit-widget-react">
        What&apos;s new?
      </div>
    </div>
  );
});
